export default __webpack_public_path__ + "static/media/feature-4.8ba1bd36.png";